export var Maybe;
(function (Maybe) {
    const SomeTypeSymbol = Symbol('Maybe.some');
    const NoneTypeSymbol = Symbol('Maybe.none');
    Maybe.some = (value) => ({
        type: SomeTypeSymbol,
        value,
    });
    Maybe.none = { type: NoneTypeSymbol };
    Maybe.isSome = (option) => (option === null || option === void 0 ? void 0 : option.type) === SomeTypeSymbol;
    Maybe.isNone = (option) => (option === null || option === void 0 ? void 0 : option.type) === NoneTypeSymbol;
    Maybe.map = (mapFn) => (option) => Maybe.isNone(option) ? Maybe.none : Maybe.some(mapFn(option.value));
    Maybe.unwrapThrow = (option) => {
        if (Maybe.isNone(option)) {
            throw new Error('`unwrapThrow()` has failed because it is `None`');
        }
        return option.value;
    };
    Maybe.unwrap = (option) => Maybe.isNone(option) ? undefined : option.value;
    Maybe.unwrapOr = (option, defaultValue) => Maybe.isNone(option) ? defaultValue : option.value;
    Maybe.expectToBe = (message) => (option) => {
        if (Maybe.isNone(option)) {
            throw new Error(message);
        }
        return option.value;
    };
})(Maybe || (Maybe = {}));
